export const WORKOS_AUTHKIT_ENTRY_PATH = "/login/workos"
export const WORKOS_AUTHKIT_CALLBACK_PATH = "/login/workos/callback"
// The callback is a route handler, so it has no UI of its own to fail into —
// every failure redirects here with a `reason`.
export const WORKOS_AUTHKIT_ERROR_PATH = "/login/workos/error"
// Must be registered as a Logout URI in the WorkOS dashboard (and set as the
// default), or WorkOS rejects it as a `return_to` target.
export const WORKOS_AUTHKIT_SIGNED_OUT_PATH = "/login/workos/signed-out"

/**
 * Failure surfaces of the AuthKit callback. Each value is also a key under
 * `auth.workos.errors` in every locale file, so adding one means adding copy.
 */
export const WORKOS_CALLBACK_ERROR_KEYS = [
  "authKit",
  "missingCode",
  "missingIdentity",
  "userDisabled",
  "noOrganization",
  "network",
  "generic",
] as const

export type WorkosCallbackErrorKey = (typeof WORKOS_CALLBACK_ERROR_KEYS)[number]

// Set by the callback route, read and cleared by the browser — so the name has
// to live in this client-safe module, not beside the setter in the server-only
// `pendingLoginEventCookie.ts`.
export const PENDING_LOGIN_EVENT_COOKIE = "siro_pending_login_event"
